import UpdateAvailablePage from './UpdateAvailablePage';

export default UpdateAvailablePage;
